var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"t-heading-xs t-bold s-mb-xs",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('span',{staticClass:"t-md"},[_vm._v("- En del av Scenkonst Öst")])])}
var staticRenderFns = []

export { render, staticRenderFns }